import React, { useEffect, useState, useRef } from "react";
import "./FundInvoice.css";
import InvoiceList from "../../../components/FundRelease/InvoiceList";
import PaymentInvoiceList from "../../../components/FundRelease/PaymentInvoiceList";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SubHeader from "../../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../../components/Tools/Breadcumbs";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

const FundInvoice = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedInvoice, setSelectednvoice] = useState([]);
  const [selectedPaymentInvoice, setSelectedPaymentInvoice] = useState([]);
  const [key, setKey] = useState("InvoiceList");
  const searchParams = new URLSearchParams(location.search);
  const active = searchParams.get("active");
  const pending = searchParams.get("pending");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchStr, setToSearchStr] = useState("");
  const [heading, setHeading] = useState("Invoice Approve");
  const [dateColumn, setDateColumn] = useState("voucher_date");
  const fyList = financialYears.payload.fy_list;
  const fyIdRef = useRef(localStorage.getItem("globalDateId"));

  const handleDateChange = (start, end, dateColumn, searchStr) => {
    setFromDate(start);
    setToDate(end);
    setDateColumn(dateColumn);
    setToSearchStr(searchStr);
  };

  useEffect(() => {
    if (pending == "true") {
      setHeading("Payment Approval");
      navigate("/fund-invoice-list?pending=true");
      setKey("paymentStatus");
    } else {
      setHeading("Invoice Approval");
      navigate("/fund-invoice-list?pending=false");
      setKey("InvoiceList");
    }
  }, [pending]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handlePageTrigger = () => {
    fyIdRef.current = localStorage.getItem("globalDateId");
  };
  const [all, setAll] = useState(false);
  const handleToggleChange = (e) => {
    let val = all === false ? true : false;
    setAll(val);
  };
  const proceedToApproval = () => {
    if(!selectedInvoice.length) {
        toast.success('Please select invoice.', { position: toast.POSITION.TOP_CENTER, });
        return;
    }
    navigate('/fund-approval', { state: { data: selectedInvoice } });
    };
  
  const proceedToPaymentApproval = () => {
    if(!selectedPaymentInvoice.length) {
        toast.success('Please select invoice.', { position: toast.POSITION.TOP_CENTER, });
        return;
    }
    navigate('/fund-proceed-for-payment', { state: { data: selectedPaymentInvoice } });
    };
  return (
    <div>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
      <div className="scheme p-2">
        <div className="row" style={{ padding: "10px 16px" }}>
          <div className="col-md-4">
            <h4 style={{ color: "#28326f", margin: 0 }}>{heading}</h4>
            <CustomBreadcrumbs linksArray={[]} title={heading} />
          </div>
          <div className="col-md-8">
            <div
              className="d-flex gap-2"
              style={{ width: "auto", float: "right" }}
            >
                {key == "InvoiceList" ? (
                    <>
                      <button type="button" className="submit_button" disabled={authData.user.user_type === 'l1'} onClick={() => proceedToApproval()}>{selectedInvoice.length} Proceed for Approval </button>
                      <button
                        type="button"
                        className="navigation_button"
                        onClick={() => navigate("/fund-invoice-list?pending=true")}
                      >
                        <span className="fs-14px">Payment Approval</span>
                      </button>
                    </>
                ) : (
                    <>
                      <button type="button" className="submit_button" disabled={authData.user.user_type === 'l1'} onClick={() => proceedToPaymentApproval()}>{selectedPaymentInvoice.length} Proceed for Payment </button>
                      <button
                        type="button"
                        className="navigation_button"
                        onClick={() => navigate("/fund-invoice-list?pending=false")}
                      >
                        <span className="fs-14px">Invoice Approval</span>
                      </button>
                    </>
                )}
              
              <button
                type="button"
                className="navigation_button"
                onClick={() => navigate("/invoices")}
              >
                <span className="fs-14px">Vendor Payment</span>
              </button>
              {key == "InvoiceList" && 
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <p>All</p>
                <AntSwitch
                  defaultChecked
                  inputProps={{ "aria-label": "ant design" }}
                  onChange={handleToggleChange}
                />
                <p>Pending</p>
              </Stack>}
            </div>
          </div>
        </div>

        {pending === 'false' ? (
          <InvoiceList
            selectedInvoice={selectedInvoice}
            setSelectednvoice={setSelectednvoice}
            fromDate={fromDate}
            toDate={toDate}
            dateColumn={dateColumn}
            searchStr={searchStr}
            approval={true}
            all={all}
          />
        ) : (
          <PaymentInvoiceList
            selectedPaymentInvoice={selectedPaymentInvoice}
            setSelectedPaymentInvoice={setSelectedPaymentInvoice}
            fromDate={fromDate}
            toDate={toDate}
            dateColumn={dateColumn}
            searchStr={searchStr}
            isChecked={isChecked}
            approval={true}
          />
        )}
      </div>
    </div>
  );
};

export default FundInvoice;
